import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  TuiButton,
  TuiDialogService,
  tuiItemsHandlersProvider,
} from '@taiga-ui/core';
import {
  FieldOptionValue,
  WorkflowFormFieldBase,
} from '@features/requests/request-form/components/request-form-workflows/types';
import { TranslatePipe } from '@ngx-translate/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MistakesFormComponent } from './mistakes-form/mistakes-form.component';
import { RequestModel } from '@core/models';
import { XAlertService } from '@core/services';
import { WorkflowService } from '@core/services/workflow/workflow.service';
import { MistakeType } from '@workflows/types';

@Component({
  selector: 'x-input-mistakes-field',
  imports: [ReactiveFormsModule, TranslatePipe, TuiButton],
  templateUrl: './input-mistakes-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
  providers: [
    tuiItemsHandlersProvider({
      stringify: signal((item: FieldOptionValue) => item.title),
    }),
  ],
})
export class InputMistakesFieldComponent implements OnInit {
  field = input.required<WorkflowFormFieldBase>(); // TODO нужен отдельный тип для этого поля
  control = input.required<FormControl<string[]>>();
  request = input<RequestModel | null>(null);
  workflowId = input.required<string>();
  canExecute = input<boolean>(true);

  private readonly dialogService$ = inject(TuiDialogService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly workflowService = inject(WorkflowService);
  private readonly xAlertService = inject(XAlertService);

  protected mistakesTypes: MistakeType[] = [];

  ngOnInit() {
    if (!this.request()) {
      return;
    }

    this.workflowService
      .getMistakesTypes(this.request()!.counterpartyOwnerId.id)
      .subscribe((mistakesTypes: MistakeType[]) => {
        this.mistakesTypes = mistakesTypes;
      });
  }

  protected openMistakesModal() {
    if (this.mistakesTypes.length === 0) {
      this.xAlertService.error('Для этой заявки нет списка ошибок');

      return;
    }

    this.dialogService$
      .open(new PolymorpheusComponent(MistakesFormComponent), {
        closable: true,
        dismissible: true,
        size: 'l',
        data: {
          request: this.request(),
          workflowId: this.workflowId(),
          mistakesTypes: this.mistakesTypes,
        },
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }
}
